<template>
  <div>
      <h2>Operations</h2>
      <button @click="sendReminderEmail()">Email an Händler, Vermieter und Service Partner</button>

      <div v-show="showReminder" style="margin-top: 5px;">
        <h3>1. Email-Inhalt bearbeiten</h3>
        <button @click="openEmailEditor()" class="edit">Email ansehen/bearbeiten</button>
        <h3>2. Email zuschicken lassen</h3>
        Test-Email-Adresse: <input type="text" v-model="testemailadress"><br>
          <button @click="sendTestEmail()" class="subbutton">Test-Email senden</button><br>

        <h3>3. Email an folgende Händler schicken?</h3>
        <button @click="sendImportenNotificationEmail()" class="subbutton">An alle Händler</button>&nbsp;
        <button @click="sendImportenNotificationEmail()" class="subbutton">An Händler die in den letzen 90 Tagen aktiv waren</button>

        <br>

      </div>

      <br>
        ********
      <br>
      <button @click="notActiveSince180Days()">Alle Händler die seit 180 Tagen nicht mehr aktiv waren</button>
      <br>
      <button @click="notActiveSince360Days()">Alle Händler die seit 360 Tagen nicht mehr aktiv waren</button>
      <br>
      <button @click="activeWithin30Days()">Alle Händler die in den letzen 30 Tagen aktiv waren</button>
      <br>
      <button @click="activeWithin5Days()">Alle Händler die in den letzen 5 Tagen aktiv waren</button>
      <br>
      <button @click="lastSyncJobsLogs()">Die letzten 20 SyncJob Logeinträge</button>
      <div name="response">
      <h2>Response</h2>
      <div class="responseText" v-html="responseText">
      </div>
      </div>
  </div>
</template>

<script>

import User from '../enteties/User';
import Config from '../Config'

export default {
  name: 'Operations',
  props: {},
  components: {
  },
  data: function() {
    return {
      user: User,
      config: Config,
      showReminder: false,
      responseText: '',
      testemailadress: ''
    }
  },
  created: function() {

    if(!this.user.logedin){
        this.$router.push({ path: 'login' })
    }

  },
  methods: {
    sendReminderEmail: function(){
      this.showReminder = !this.showReminder;
    },
    notActiveSince180Days: function(){
      var oReq = new XMLHttpRequest();

      oReq.addEventListener("load", () => {
        let dealer = JSON.parse(oReq.responseText);
        let html = "Gesamt:  <b>" + dealer.length + "</b> <ul>";

        for(let d in dealer){
          html += "<li>" + dealer[d].firma + "</li>";
        }

        html+="</ul>";
        this.responseText = html;
      });

      oReq.addEventListener("error", () => {
        //alert(oReq.statusText);
      });

      oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/dealer?notActiveSince=180");

      oReq.setRequestHeader("x-access-token", this.config.masterpassword);
      oReq.send();
    },
    notActiveSince360Days: function(){
      var oReq = new XMLHttpRequest();

      oReq.addEventListener("load", () => {
        let dealer = JSON.parse(oReq.responseText);

        let html = "Gesamt:  <b>" + dealer.length + "</b> <ul>";

        for(let d in dealer){
          html += "<li>" + dealer[d].firma + "</li>";
        }

        html+="</ul>";
        this.responseText = html;
      });

      oReq.addEventListener("error", () => {
        //alert(oReq.statusText);
      });

      oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/dealer?notActiveSince=360");

      oReq.setRequestHeader("x-access-token", this.config.masterpassword);
      oReq.send();
    },
    activeWithin30Days: function(){
      var oReq = new XMLHttpRequest();

      oReq.addEventListener("load", () => {
        let dealer = JSON.parse(oReq.responseText);
        let html = "Gesamt:  <b>" + dealer.length + "</b> <ul>";

        for(let d in dealer){
          html += "<li>" + dealer[d].firma + "</li>";
        }

        html+="</ul>";
        this.responseText = html;
      });

      oReq.addEventListener("error", () => {
        //alert(oReq.statusText);
      });

      oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/dealer?activeWithinThelast=30");

      oReq.setRequestHeader("x-access-token", this.config.masterpassword);
      oReq.send();
    },
    activeWithin5Days: function(){
      var oReq = new XMLHttpRequest();

      oReq.addEventListener("load", () => {
        let dealer = JSON.parse(oReq.responseText);
        let html = "Gesamt:  <b>" + dealer.length + "</b> <ul>";

        for(let d in dealer){
          html += "<li>" + dealer[d].firma + "</li>";
        }

        html+="</ul>";
        this.responseText = html;
      });

      oReq.addEventListener("error", () => {
        //alert(oReq.statusText);
      });

      oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/dealer?activeWithinThelast=5");

      oReq.setRequestHeader("x-access-token", this.config.masterpassword);
      oReq.send();
    },
    lastSyncJobsLogs: function(){
      var oReq = new XMLHttpRequest();

      oReq.addEventListener("load", () => {
        let log = JSON.parse(oReq.responseText);
        let html = "<ul>";

        for(let d in log){
          html += "<li>" + log[d].text + " : " + log[d].logdate +  " : <b>" + log[d].state + "</b></li><br>";
        }

        html+="</ul>";
        this.responseText = html;
      });

      oReq.addEventListener("error", () => {
        //alert(oReq.statusText);
      });

      oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/cronjobs/lastLogs/20");

      oReq.setRequestHeader("x-access-token", this.config.masterpassword);
      oReq.send();
    },
    sendImportenNotificationEmail: function(){
      this.$dialog
      .confirm('Sollen die Email wirklich an die Händler gesendet werden?')
      .then((dialog) => {
        //console.log('Clicked on proceed');
        alert("Noch nicht aktiv");
      })
      .catch(function() {
        //console.log('Clicked on cancel');
      });
    },
    sendTestEmail: function(){
      this.$dialog
      .confirm('Soll die Email wirklich gesendet werden?')
      .then((dialog) => {
        if(this.testemailadress != undefined && this.testemailadress != ""){
          var oReq = new XMLHttpRequest();

          oReq.addEventListener("load", () => {
            this.responseText = oReq.responseText;
          });

          oReq.addEventListener("error", () => {
            //alert(oReq.statusText);
          });

          oReq.open("GET", this.config.protocol + "://" + this.config.apihost + "/private/dealer/sendTestEmail/" + this.testemailadress);

          oReq.setRequestHeader("x-access-token", this.config.masterpassword);
          oReq.send();
        }
      })
      .catch(function() {
        //console.log('Clicked on cancel');
      });
    },
    openEmailEditor: function(){
        this.$router.push({ path: 'emaileditor' })
    }
  }
}
</script>

<style>
.responseText {
  background-color: #eeeeee;
  width: 80%;
  min-height: 50px;
  margin:auto;
  padding: 8px;
}

button {
  margin-bottom: 12px;
}

.subbutton{
  border-color: green;
}

.edit {
  border-color: #0096d9;
}
</style>
